import { useQuery } from '@apollo/client'
import { ExpensableGroupsStatusCountsDocument } from 'generated/resources/graphql'

import type { StatusCounts } from 'modules/expenses/components/expenses/DataCollection/useExpensesPresetsConfig'

interface UseExpensableGroupsStatusCountsParams {
  companyId: string
  employeeIds?: string[]
  from?: Date
  to?: Date
}

interface UseExpensableGroupsStatusCountsResult {
  data: StatusCounts | undefined
  loading: boolean
}

export const useExpensableGroupsStatusCounts = ({
  companyId,
  employeeIds,
  from,
  to,
}: UseExpensableGroupsStatusCountsParams): UseExpensableGroupsStatusCountsResult => {
  const { data, loading, previousData } = useQuery(ExpensableGroupsStatusCountsDocument, {
    variables: {
      companyId,
      employeeIds,
      from,
      to,
    },
    fetchPolicy: 'cache-and-network',
  })

  // Use previousData while loading to prevent counters from disappearing
  const activeData = data ?? previousData

  if (!activeData) {
    return { data: undefined, loading }
  }

  return {
    data: {
      draft: activeData.expenses.draftCount.totalCount ?? 0,
      pending: activeData.expenses.pendingCount.totalCount ?? 0,
      approved: activeData.expenses.approvedCount.totalCount ?? 0,
      paid: activeData.expenses.paidCount.totalCount ?? 0,
    },
    loading,
  }
}
